export default "/images/corner-down-right.svg?ccebc9427f1853c1b5f7b776b0799a97";